import { Link } from 'react-router';
import { cn } from '@/lib/utils';
import type { CarryStructureEntity } from '@/types/carryFund';

export type CarryEntityBoxVariant = 'STAK' | 'COOPERATIVE';

const VARIANTS: Record<
  CarryEntityBoxVariant,
  { box: string; label: string | null; name: string; link: string }
> = {
  STAK: {
    box: 'w-64 border-amber-300 bg-amber-50 p-4 hover:border-amber-400 hover:bg-amber-100 dark:border-amber-800 dark:bg-amber-950/30 dark:hover:bg-amber-950/50',
    label: 'DR holders',
    name: 'text-foreground',
    link: 'text-amber-700 dark:text-amber-400',
  },
  COOPERATIVE: {
    box: 'min-w-[360px] border-blue-200 bg-blue-50 px-6 py-4 text-center hover:bg-blue-100 dark:border-blue-900 dark:bg-blue-950/30 dark:hover:bg-blue-950/50',
    label: null,
    name: 'text-blue-800 dark:text-blue-300',
    link: 'text-blue-800 dark:text-blue-300',
  },
};

interface CarryEntityBoxProps {
  entity: CarryStructureEntity;
  variant: CarryEntityBoxVariant;
  to: string;
}

export function CarryEntityBox({ entity, variant, to }: CarryEntityBoxProps) {
  const styles = VARIANTS[variant];

  return (
    <Link
      to={to}
      className={cn('block rounded-lg border transition-colors', styles.box)}
    >
      {styles.label && (
        <p
          className={cn(
            'text-xs font-medium uppercase tracking-wide',
            styles.link
          )}
        >
          {styles.label}
        </p>
      )}
      <p className={cn('mt-1 font-semibold', styles.name)}>
        {entity.name ?? '—'}
      </p>
      <p className="text-sm tabular-nums text-muted-foreground">
        CoC {entity.coc_number ?? '—'}
      </p>
      <p className={cn('mt-3 text-sm font-medium', styles.link)}>
        View details →
      </p>
    </Link>
  );
}
